import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../modules/angular-material/angular-material.module';
import { FaqsComponent } from './components/faqs.component';

@NgModule({
  imports: [CommonModule, AngularMaterialModule],
  declarations: [FaqsComponent],
  exports: [FaqsComponent],
})
export class FaqsModule {}
